<div class="main-modal-container">
  <div class="close-modal-container">
    <img
      (click)="closeModal()"
      src="/assets/icons/ close-modal-icon.png"
      alt=""
    />
  </div>
  <div class="modal-content">
    <h1 class="label-title">Your Account Is Now Ready!</h1>
    <button (click)="navigateLogin()" class="buttons" gbui-button type="submit">
      Sign-In
    </button>
  </div>
</div>
